export function sortGroupData(data, orderBy) {
  let isAsc = true;
  if (!data?.length) {
    return data;
  }
  const stabilizedThis = data.map((el, index) => el);
  stabilizedThis.sort((a, b) => {
    let valA = a[orderBy] || 0;
    let valB = b[orderBy] || 0;
    if (valA !== valB) {
      if (isAsc) {
        return valB - valA;
      } else {
        return valA - valB;
      }
    }

    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  });
  let place = 1;
  stabilizedThis[0].place = 1;

  for (let i = 1; i < stabilizedThis.length; i++) {
    if (stabilizedThis[i - 1][orderBy] !== stabilizedThis[i][orderBy]) {
      place = i + 1;
    }
    stabilizedThis[i].place = place;
  }

  return stabilizedThis;
}

export function gameSystemNameFromGameType(gameType) {
  if (!gameType) return "";
  let _gameType = parseInt(gameType);
  if (_gameType === 1) return "Warhammer 40,000";
  if (_gameType === 4) return "Warhammer Age of Sigmar";
  if (_gameType === 26) return "Warhammer 40,000: Kill Team";
  if (_gameType === 9) return "Warhammer Underworlds";
  return "";
}
